import { useState, useEffect } from "react";
import {
  fetchContenidosDinamicos,
  fetchParametros,
  getUltimaActualizacion,
  getListasParametro,
  updateParametros,
  descargarReporte,
} from "../../components/functions/Projects";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "./Modal.css";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography, Paper, Button } from "@mui/material";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Chip from "@mui/material/Chip";
import Link from "@mui/icons-material/Link";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import LoaderDialog from "../../ui/loader/Loader";
import Snackbar from "@mui/material/Snackbar";
import CustomButton from "../../ui/button/Button";

export const ParametrosModal = ({
  API_URL,
  showModal = true,
  handleCloseModal = () => {},
  trabajoId,
  trabajoName,
  trabajo = null,
  timestamp = null,
}) => {
  const [contenidosDinamicos, setContenidosDinamicos] = useState([]);
  const [selectedContenidoDinamico, setSelectedContenidoDinamico] =
    useState(null);
  const [parametros, setParametros] = useState([]);
  const [ultimaActualizacion, setUltimaActualizacion] = useState("");
  const [listasParametro, setListasParametro] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const resContenidos = await fetchContenidosDinamicos(API_URL, trabajoId);
      resContenidos.forEach((fase) => {
        if (fase.descripcion === "Entregable") {
          fase.descripcion = "Implementación";
        }
      });
      setContenidosDinamicos(resContenidos || []);
      if (resContenidos.length > 0) {
        setSelectedContenidoDinamico(resContenidos[0]);
      }
    };
    if (trabajoId) {
      fetchData();
    }
  }, [trabajoId, timestamp]);

  useEffect(() => {
    const fetchData = async () => {
      const [resParametros, resListasParametro, resUltimaActualizacion] =
        await Promise.all([
          fetchParametros(API_URL, selectedContenidoDinamico?.id),
          getListasParametro(API_URL),
          getUltimaActualizacion(API_URL, trabajoId, "PARAMETROS"),
        ]);

      setListasParametro(resListasParametro || []);
      setUltimaActualizacion(resUltimaActualizacion.respuesta);
      setParametros(resParametros || []);
    };
    if (selectedContenidoDinamico) {
      fetchData();
    }
  }, [selectedContenidoDinamico, timestamp]);

  const updateParametro = (id, tipo, value) => {
    const parametro = parametros.find((p) => p.id === id);
    if (tipo === "string") {
      parametro.texto = value;
    } else if (tipo === "entero") {
      parametro.entero = parseInt(value);
    } else if (tipo === "flotante") {
      parametro.valorPuntoFlotante = parseFloat(value);
    } else if (tipo === "boolean") {
      parametro.condicional = value;
    } else if (tipo === "date") {
      parametro.fecha = value;
    } else if (tipo === "lista") {
      const listaParametro = listasParametro.find(
        (item) => item.id === parametro.listaParametroId
      );
      const selection = listaParametro.elementosListaParametro.find(
        (e) => e.id == value
      );
      parametro.elementoListaParametro = selection || null;
    } else if (tipo === "link") {
      parametro.texto = value;
    }
    setParametros([...parametros]);
  };

  const guardarCambios = async () => {
    try {
      setShowLoader(true);
      await updateParametros(
        API_URL,
        selectedContenidoDinamico?.id,
        parametros
      );
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("Cambios guardados con éxito");
    } catch (error) {
      setShowLoader(false);
      console.error("Error al guardar los cambios:", error);
    }
  };

  const cerrarYLimpiarTodo = () => {
    handleCloseModal();
    setContenidosDinamicos([]);
    setSelectedContenidoDinamico(null);
    setParametros([]);
    setListasParametro([]);
    setUltimaActualizacion("");
  };

  const descargar = async () => {
    try {
      setShowLoader(true);
      const response = await descargarReporte(
        API_URL,
        selectedContenidoDinamico?.id
      );
      const blob = new Blob([response], {
        type: "application/pdf",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${trabajoName}_${selectedContenidoDinamico?.descripcion}.pdf`;
      setShowLoader(false);
      link.click();
      URL.revokeObjectURL(url);
      setShowSnackbar(true);
      setSnackbarMessage("Reporte descargado con éxito");
    } catch (error) {
      setShowLoader(false);
      console.error("Error al descargar el reporte:", error);
    }
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={false}
        onClose={cerrarYLimpiarTodo}
        open={showModal}
      >
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            height: "80vh",
          }}
        >
          <Box sx={{ width: "100%", overflowY: "scroll" }}>
            <Box
              sx={{
                height: "50px",
                padding: "20px",
              }}
            >
              <Typography sx={{ fontSize: "18px" }} align="left">
                Parámetros trabajo - {trabajoName}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
                sx={(theme) => ({
                  position: "absolute",
                  right: 0,
                  top: 6,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                height: "50px",
                padding: "20px",
                display: "flex",
                gap: "20px",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Button
                onClick={descargar}
                sx={{
                  backgroundColor: "rgb(247, 144, 30)",
                  textTransform: "none",
                }}
                variant="contained"
              >
                Descargar Reporte {selectedContenidoDinamico?.descripcion || ""}
              </Button>
              {/* <Chip onClick={() => {}} label="Copiar URL" icon={<Link />} /> */}
              <Typography sx={{ fontSize: "16px", color: "grey" }}>
                Última modificación: {ultimaActualizacion}
              </Typography>
            </Box>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              <Tabs
                variant="fullWidth"
                value={selectedContenidoDinamico?.id || null}
                onChange={(e, value) =>
                  setSelectedContenidoDinamico(
                    contenidosDinamicos.find((c) => c.id === value)
                  )
                }
              >
                {contenidosDinamicos.length > 0 &&
                  contenidosDinamicos.map((contenido) => (
                    <Tab
                      label={contenido.descripcion}
                      value={contenido.id}
                      key={contenido.id}
                    />
                  ))}
              </Tabs>
            </Box>
            <Box sx={{ padding: "20px" }}>
              {parametros.length > 0 ? (
                <Box>
                  {/* Header Row */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "200px 200px 200px 1fr",
                      backgroundColor: "#f5f5f5",
                      padding: "10px 16px",
                      borderRadius: "6px",
                      fontWeight: "bold",
                      mb: 1,
                    }}
                  >
                    <Typography align="center">Categoría</Typography>
                    <Typography align="center">Nombre</Typography>
                    <Typography align="center">Tipo</Typography>
                    <Typography align="center">Valor</Typography>
                  </Box>

                  {/* Data Rows */}
                  {parametros.map((parametro) => (
                    <Paper
                      key={parametro.id}
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "200px 200px 200px 1fr",
                        alignItems: "center",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        mb: 2,
                      }}
                    >
                      <Typography align="center">
                        {parametro.categoria}
                      </Typography>
                      <Typography align="center">
                        {parametro.tipoParametroTrabajo.nombre}
                      </Typography>
                      {parametro.tipoParametroTrabajo.tipoParametro.esLink ? (
                        <Typography
                          sx={{
                            textDecoration: "underline",
                            cursor: "pointer",
                            color: "rgb(247, 144, 30)",
                          }}
                          align="center"
                          onClick={() => {
                            window.open(parametro.texto, "_blank");
                          }}
                        >
                          Link
                        </Typography>
                      ) : parametro.tipoParametroTrabajo.tipoParametro
                          .esList ? (
                        <Typography align="center">
                          {
                            parametro.tipoParametroTrabajo.tipoParametro
                              .descripcion
                          }{" "}
                          - {parametro.listaParametroNombre}
                        </Typography>
                      ) : (
                        <Typography align="center">
                          {
                            parametro.tipoParametroTrabajo.tipoParametro
                              .descripcion
                          }
                        </Typography>
                      )}

                      {(parametro.tipoParametroTrabajo.tipoParametro.esString ||
                        parametro.tipoParametroTrabajo.tipoParametro
                          .esLink) && (
                        <input
                          type="text"
                          value={parametro.texto || ""}
                          onChange={(e) => {
                            updateParametro(
                              parametro.id,
                              "string",
                              e.target.value
                            );
                          }}
                        />
                      )}
                      {parametro.tipoParametroTrabajo.tipoParametro.esInt && (
                        <input
                          type="number"
                          value={parametro.entero || ""}
                          onChange={(e) => {
                            updateParametro(
                              parametro.id,
                              "entero",
                              e.target.value
                            );
                          }}
                        />
                      )}
                      {parametro.tipoParametroTrabajo.tipoParametro.double && (
                        <input
                          type="number"
                          value={parametro.valorPuntoFlotante || ""}
                          onChange={(e) => {
                            updateParametro(
                              parametro.id,
                              "flotante",
                              e.target.value
                            );
                          }}
                        />
                      )}
                      {parametro.tipoParametroTrabajo.tipoParametro.date && (
                        <DatePicker
                          selected={parametro.fecha}
                          onChange={(date) => {
                            updateParametro(
                              parametro.id,
                              "date",
                              date.toISOString()
                            );
                          }}
                          className={`parametro-date`}
                          dateFormat="dd/MM/yyyy"
                        />
                      )}
                      {parametro.tipoParametroTrabajo.tipoParametro.name ===
                        "BOOLEAN" && (
                        <FormGroup
                          sx={{ height: "min-content", textWrap: "nowrap" }}
                        >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={parametro.condicional === true}
                                onChange={(e) => {
                                  updateParametro(
                                    parametro.id,
                                    "boolean",
                                    e.target.checked
                                  );
                                }}
                              />
                            }
                            label={parametro.condicional ? "Sí" : "No"}
                          />
                        </FormGroup>
                      )}
                      {parametro.tipoParametroTrabajo.tipoParametro.esList && (
                        <select
                          className="select-comentarios"
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "16px",
                            color: "#555",
                            height: "39px",
                          }}
                          value={parametro.elementoListaParametro?.id || ""}
                          onChange={(e) => {
                            updateParametro(
                              parametro.id,
                              "lista",
                              e.target.value
                            );
                          }}
                        >
                          <option value={null}>Seleccione una opción</option>
                          {listasParametro
                            .find(
                              (item) => item.id === parametro.listaParametroId
                            )
                            ?.elementosListaParametro.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </select>
                      )}
                    </Paper>
                  ))}
                </Box>
              ) : (
                <Typography variant="body1">Sin parámetros</Typography>
              )}
            </Box>
          </Box>
          <div
            style={{
              justifyContent: "center",
              padding: "20px",
              position: "relative",
              backgroundColor: "white",
              width: "100%",
            }}
          >
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <CustomButton
                background="#223D51"
                color="#FFFFFF"
                text="Guardar"
                width="140px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="none"
                onClick={guardarCambios}
                type="button"
                hoverShadow="0 4px 12px rgba(0,0,0,0.2)"
              />
            </div>
          </div>
        </div>
      </Dialog>
      <LoaderDialog open={showLoader} />
    </>
  );
};
